import { Routes, Route } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";

// Temporarily disabling sub-pages to isolate the RefrenceError initialization crash
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}
